export default __webpack_public_path__ + "static/media/menuBurger.195c9f50.svg";